"use client";

import React, { useEffect, useState } from "react";
import DataLayer from "@/components/data-layer/data-layer";
import { Banner } from "@/types/contentful/banner";

interface PromotionalBannerAnalyticsProps {
  banner: Banner;
}

/**
 * Client component to handle analytics tracking for promotional banner
 * Follows the established pattern used in destination pages
 */
export default function PromotionalBannerAnalytics({ 
  banner 
}: PromotionalBannerAnalyticsProps) {
  const [dataLayerProps, setDataLayerProps] = useState<Record<string, any> | null>(null);

  useEffect(() => {
    setDataLayerProps({
      promotionalBanner: {
        bannerId: banner.id,
        bannerRank: banner.bannerRank,
        bannerBackgroundColor: banner.bannerBackgroundColor,
        bannerUrl: banner.bannerUrl,
        isGlobal: banner.isGlobal,
        bannerStartDate: banner.bannerStartDate,
        bannerEndDate: banner.bannerEndDate
      }
    });
  }, [banner]);

  return dataLayerProps && <DataLayer data={dataLayerProps} />;
}